import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.css'],
  imports: [CommonModule],
})
export class PageHeaderComponent {
  @Input() title = '';
  @Input() description = '';
}
